import { render, staticRenderFns } from "./footerPlan.vue?vue&type=template&id=8323f73e&scoped=true&"
import script from "./footerPlan.vue?vue&type=script&lang=js&"
export * from "./footerPlan.vue?vue&type=script&lang=js&"
import style0 from "./footerPlan.vue?vue&type=style&index=0&id=8323f73e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8323f73e",
  null
  
)

export default component.exports